import React, {createContext, useState} from "react";
import Notification from "../../components/common/Notification";
import BkashPaymentService from "../../services/BkashPaymentService";
import {getErrorMessage} from "../../helpers/Utils";

export const PMSBkashPaymentTransactionContext = createContext("PMSBkashPaymentTransactionContext");

const PMSBkashPaymentTransactionContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [transactions, setTransactions] = useState([]);

    const getAllBkashPaymentTransaction = async (id) => {
        try {
            setLoading(true);

            const res = await BkashPaymentService.getAllBkashPaymentTransaction(id);
            setTransactions(res.data);

            setLoading(false);

            return true;

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Notification("error", "ERROR", message);

            return false;
        }
    };


    return (
        <PMSBkashPaymentTransactionContext.Provider
            value={{
                loading,
                transactions,
                getAllBkashPaymentTransaction,
            }}
        >
            {children}
        </PMSBkashPaymentTransactionContext.Provider>
    );
};

export default PMSBkashPaymentTransactionContextProvider;
